import { useEffect } from "react";
import { useAppSelector } from "store/store";
import tinycolor from "tinycolor2";
import { changeColorURLParam } from "../../Preview/ColorPickerEditor/useColorPickerEditor";

export const useColor = () => {
    const selectedColor = useAppSelector((state) => state.colorPicker.selectedColor);
    useEffect(() => {
        selectedColor && changeColorURLParam(tinycolor(selectedColor.hex));
    }, [selectedColor]);
    return { selectedColor };
};
